import type { FireAnalyticsEvent } from '../../types';

export type AIAnswerResultSuppressedArgs = {
	source: string;
	searchSessionId: string;
	queryHash: string;
	queryIntent: string;
	queryIntentRequestId?: string | null;
	selectedProduct?: string;
	hasRefinementFilters: boolean;
};

/**
 * Counterpart of `aiAnswerResult shown`, so it keeps that event's flat attributes rather than this
 * package's nested common and additional attributes.
 *
 * Fires before any answer is requested, so it also counts renders where only a banner, bookmark or
 * hero nav card would have shown. Filter on `queryIntent` to count only answers and knowledge cards.
 */
export const onAIAnswerResultSuppressed = ({
	source,
	searchSessionId,
	queryHash,
	queryIntent,
	queryIntentRequestId,
	selectedProduct,
	hasRefinementFilters,
}: AIAnswerResultSuppressedArgs): FireAnalyticsEvent => ({
	source,
	eventType: 'track',
	action: 'suppressed',
	actionSubject: 'aiAnswerResult',
	attributes: {
		searchSessionId,
		queryHash,
		queryIntent,
		queryIntentRequestId: queryIntentRequestId ?? null,
		selectedProduct: selectedProduct || null,
		hasRefinementFilters,
	},
});
